<template>
  <div id="pdf"
    style="top: 0px;left: 0px;right: 0px;bottom: 0px;background-color: white;font-size: 14px;font-family: sans-serif;overflow:scroll;">
    <div class="paper" style="width: 720px;margin: auto;">
      <table id="p-table" class="table w-full text-left whitespace-no-wrap">
        <thead v-if="type && type === 'PaymentsByseller'" class="responsive-table">
          <tr>
            <th style="background-color: #4299e1;border: 1px solid #4e504a;" :rowspan="items.length > 0 ? 3 : ''">Seller</th>
            <th style="background-color: #4299e1;border: 1px solid #4e504a;" :rowspan="items.length > 0 ? 3 : ''">Nombre
              ordres uploaded</th>
            <th style="background-color: #4299e1;border: 1px solid #4e504a;"
              :colspan="items.length > 0 ? items[0][1].length * 9 : ''">Warehouses</th>
          </tr>
          <tr v-if="items.length > 0" class="warehouses">
            <th v-for="(item, index) in items[0][1]" :key="'header-' + index" :colspan="9"
              style="background-color: #6a6a6d;color:#fff;border: 1px solid #4e504a;">{{ item.name }}</th>
          </tr>
          <tr v-if="items.length > 0" class="orders">
            <template v-for="(item1) in items[0][1]">
              <th style="background-color: #cacaca;border: 1px solid #4e504a;">Confirmed</th>
              <th style="background-color: #cacaca;border: 1px solid #4e504a;">Cancelled</th>
              <th style="background-color: #cacaca;border: 1px solid #4e504a;">Reminded</th>
              <th style="background-color: #cacaca;border: 1px solid #4e504a;">Unrached (CALLS)</th>
              <th style="background-color: #cacaca;border: 1px solid #4e504a;">Shipped</th>
              <th style="background-color: #cacaca;border: 1px solid #4e504a;">Reprogrammer</th>
              <th style="background-color: #cacaca;border: 1px solid #4e504a;">Return</th>
              <th style="background-color: #cacaca;border: 1px solid #4e504a;">Paid</th>
              <th style="background-color: #cacaca;border: 1px solid #4e504a;">Processed</th>
            </template>
          </tr>
        </thead>
        <thead v-else class="bg-gray-200">
          <tr class="text-left">
            <th class="border p-2">{{ $t('order_id') | t }}</th>
            <th class="border p-1 text-center ">{{ $t('seller') }}</th>
            <th class="border p-2 text-center">{{ $t('customer') }}</th>
            <th class="border p-2 text-center">{{ $t('phone') }}</th>
            <th class="border p-2 text-center">{{ $t('products') }}</th>
            <th class="border p-2 text-center">{{ $t('quantity') }}</th>
            <th class="border p-2 text-center">{{ $t('totalPrice') }}</th>
            <th class="border p-2 text-center">{{ $t('address') }}</th>
            <th class="border p-2 text-center">{{ $t('order_date') }}</th>
            <th class="border p-2 text-center">{{ $t('status') }}</th>
            <th class="border p-2 text-center">{{ $t('comment') }}</th>
          </tr>
        </thead>
        <tbody v-if="type && type === 'PaymentsByseller'" class="relative">
          <tr v-for="(ele, index) in items" :key="'seller-' + index" class="intro-x">
            <td style="width: 200px;white-space: nowrap;position: sticky; left: 0px;" scope="row"
              class="text-left-imp font-bold text-gray-700 fz-14 ant-table-cell-fix-right ant-table-cell-fix-right-first">
              {{ ele[3] }}
            </td>
            <td style="width: 200px;white-space: nowrap;" scope="row"
              class="text-left-imp font-bold text-gray-700 fz-14">
              {{ ele[2] }}
              <!-- <span class="flex">
                      <span v-for="(ware, index) in ele[1].filter(ts=> (ts.sumConfirmed+ts.sumRemind+ts.sumUnreached+ts.sumCancelled+ts.sumShipped+ts.sumReprogrammer+ts.sumReturn+ts.sumProcessed))" :key="'werrr-'+index" class="intro-x">
                      <img :src="ware.flag" class="w-4 h-4 rounded-full mr-2">
                      </span>
                  </span> -->
            </td>

            <template v-for="(item2) in ele[1]">
              <td
                :style="item2.sumConfirmed ? randomHexColor(item2.index) : 'background: repeating-linear-gradient(45deg,#FFFFFF,#FFFFFF 10px,#DDDDDD 10px,#DDDDDD 20px) !important'">
                {{ item2.sumConfirmed ? item2.sumConfirmed : '' }}</td>
              <td
                :style="item2.sumCancelled ? randomHexColor(item2.index) : 'background: repeating-linear-gradient(45deg,#FFFFFF,#FFFFFF 10px,#DDDDDD 10px,#DDDDDD 20px) !important'">
                {{ item2.sumCancelled ? item2.sumCancelled : '' }}</td>
              <td
                :style="item2.sumRemind ? randomHexColor(item2.index) : 'background: repeating-linear-gradient(45deg,#FFFFFF,#FFFFFF 10px,#DDDDDD 10px,#DDDDDD 20px) !important'">
                {{ item2.sumRemind ? item2.sumRemind : '' }}</td>
              <td
                :style="item2.sumUnreached ? randomHexColor(item2.index) : 'background: repeating-linear-gradient(45deg,#FFFFFF,#FFFFFF 10px,#DDDDDD 10px,#DDDDDD 20px) !important'">
                {{ item2.sumUnreached ? item2.sumUnreached : '' }}</td>
              <td
                :style="item2.sumShipped ? randomHexColor(item2.index) : 'background: repeating-linear-gradient(45deg,#FFFFFF,#FFFFFF 10px,#DDDDDD 10px,#DDDDDD 20px) !important'">
                {{ item2.sumShipped ? item2.sumShipped : '' }}</td>
              <td
                :style="item2.sumReprogrammer ? randomHexColor(item2.index) : 'background: repeating-linear-gradient(45deg,#FFFFFF,#FFFFFF 10px,#DDDDDD 10px,#DDDDDD 20px) !important'">
                {{ item2.sumReprogrammer ? item2.sumReprogrammer : '' }}</td>
              <td
                :style="item2.sumReturn ? randomHexColor(item2.index) : 'background: repeating-linear-gradient(45deg,#FFFFFF,#FFFFFF 10px,#DDDDDD 10px,#DDDDDD 20px) !important'">
                {{ item2.sumReturn ? item2.sumReturn : '' }}</td>
              <td
                :style="item2.sumPaid ? randomHexColor(item2.index) : 'background: repeating-linear-gradient(45deg,#FFFFFF,#FFFFFF 10px,#DDDDDD 10px,#DDDDDD 20px) !important'">
                {{ item2.sumPaid ? item2.sumPaid : '' }}</td>
              <td
                :style="item2.sumProcessed ? randomHexColor(item2.index) : 'background: repeating-linear-gradient(45deg,#FFFFFF,#FFFFFF 10px,#DDDDDD 10px,#DDDDDD 20px) !important'">
                {{ item2.sumProcessed ? item2.sumProcessed : '' }}</td>
            </template>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <th v-if="items.length == 0" class="border p-3 bg-gray-100" colspan="12">
              {{ "no_record_found" | t }}
            </th>
          </tr>
          <tr class="text-center" v-for="(item, index) in items" :key="index"
            :class="index % 2 == 0 ? 'bg-gray-100' : ''">
            <td class="border p-2">
              <span class="flex items-center">
                {{ item.id }}
              </span>
            </td>
            <td class="border p-2">
              <span class="flex items-center">
                {{ item.seller && item.seller.fullName ? item.seller.fullName : "" }}
              </span>
            </td>
            <td class="border p-2">
              <span class="flex items-center">
                {{ item.customer && item.customer.fullName ? item.customer.fullName : "" }}
              </span>
            </td>
            <td class="border p-2">
              <span class="flex items-center">
                {{ item.customer && item.customer.phone ? item.customer.phone : "" }}
              </span>
            </td>
            <td class="border p-2  bg-green-100">
              {{ sumProduct(item.details) }}
            </td>
            <td class="border p-2  bg-green-100">
              {{ sumQteProduct(item.details) }}
            </td>
            <td class="border p-2  bg-green-100">
              {{ item.totalPrice }}
            </td>
            <td class="border p-2  bg-green-100">
              {{ item.customer && item.customer.address ? item.customer.address : "" }}
            </td>
            <td class="border p-2  bg-green-100">
              {{ $moment(item.date).format('DD-MM-YYYY') }}
            </td>
            <td class="border p-2  bg-green-100">
              {{ item.status ? item.status.name : '' }}
            </td>
            <td class="border p-2  bg-green-100">
              {{ item.comment }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: Array,
    type: String,
  },
  mounted() {
    // const pdf = document.querySelector("#pdf").cloneNode(true);
    // document.querySelector("#app").before(pdf);
    // document.querySelector("#app").style.display = "none";
    // window.print();
    // pdf.remove();
    // document.querySelector("#app").style.display = "block";
    // this.exportToExcel()
    // this.$emit("printed");
    console.log('items excel____', this.items)
  },
  methods: {
    // getRestDays(endDate) {
    //   return this.$options.filters.toDays(endDate, Date.now());
    // },
    sumQteProduct(data) {
      let sum = 0;
      for (let i in data) {
        sum = sum + data[i].quantity;
      }
      return sum;
    },
    sumProduct(data) {
      let product = "";
      for (let i in data) {
        if (data[i].product && data[i].product.name) product += data[i].product.name
        if (data.length - 1 != i) product += " ,";
      }
      return product;
    },
    randomHexColor(index) {
      const colors = ["#ba96ce", "#679c9d", "#c6c42c", "#48b41b", "#5be4f0", "#57c4d8", "#a4d17a", "#225b8", "#be608b", "#96b00c", "#088baf", "#f158bf", "#e145ba", "#ee91e3", "#05d371", "#5426e0", "#4834d0", "#802234", "#6749e8", "#0971f0", "#8fb413", "#b2b4f0", "#c3c89d", "#c9a941", "#41d158", "#fb21a3", "#51aed9", "#5bb32d", "#807fb", "#21538e", "#89d534", "#d36647", "#7fb411", "#0023b8", "#3b8c2a", "#986b53", "#f50422", "#983f7a", "#ea24a3", "#79352c", "#521250", "#c79ed2", "#d6dd92", "#e33e52",];
      return 'background: ' + colors[index];
    },
  }
};
</script>
<style>
table {
  page-break-inside: auto;
}

tr {
  page-break-inside: avoid;
  page-break-after: auto;
}

thead {
  display: table-header-group;
}

tfoot {
  display: table-footer-group;
}
</style>
